import { IFormSchema } from "..";
import { IFormContext, IStrictFormContext } from "../models/IFormContext";
import ISchemaRule, { ActionType } from "../models/ISchemaRule";




export const composeRules = (
    rules: Array<ISchemaRule>,
    formSchema: IFormSchema,
    formContext: IStrictFormContext
): Array<ISchemaRule> => {

    let composedRules = [...rules];

    if (formSchema.hideEmptyFields && formContext.mode === "display") {
        composedRules.push({
            conditions: {},
            event: { type: ActionType.HideEmptyFields }
        });
    };

    return composedRules;

};


export default composeRules;